import _toConsumableArray from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { __rest } from "tslib";
import { array, isArray } from 'vega-util';
import { AXIS_PARTS, AXIS_PROPERTY_TYPE, CONDITIONAL_AXIS_PROP_INDEX, isConditionalAxisValue } from '../../axis';
import { POSITION_SCALE_CHANNELS } from '../../channel';
import { defaultTitle } from '../../channeldef';
import { isText } from '../../title';
import { getFirstDefined, isEmpty, replaceAll } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { exprFromValueOrSignalRef } from '../common';
import { expression } from '../predicate';
function assembleTitle(title, config) {
  if (!title) {
    return undefined;
  }
  if (isArray(title) && !isText(title)) {
    return title.map(function (fieldDef) {
      return defaultTitle(fieldDef, config);
    }).join(', ');
  }
  return title;
}
function setAxisEncode(axis, part, vgProp, vgRef) {
  var _a, _b, _c;
  axis.encode = (_a = axis.encode) !== null && _a !== void 0 ? _a : {};
  axis.encode[part] = (_b = axis.encode[part]) !== null && _b !== void 0 ? _b : {};
  axis.encode[part].update = (_c = axis.encode[part].update) !== null && _c !== void 0 ? _c : {};
  // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
  axis.encode[part].update[vgProp] = vgRef;
}
export function assembleAxis(axisCmpt, kind, config) {
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    header: false
  };
  var _a, _b;
  var _c = axisCmpt.combine(),
    disable = _c.disable,
    orient = _c.orient,
    scale = _c.scale,
    labelExpr = _c.labelExpr,
    title = _c.title,
    zindex = _c.zindex,
    axis = __rest(_c, ["disable", "orient", "scale", "labelExpr", "title", "zindex"]);
  if (disable) {
    return undefined;
  }
  for (var prop in axis) {
    var propType = AXIS_PROPERTY_TYPE[prop];
    var propValue = axis[prop];
    if (propType && propType !== kind && propType !== 'both') {
      // Remove properties that are not valid for this kind of axis
      delete axis[prop];
    } else if (isConditionalAxisValue(propValue)) {
      // deal with conditional axis value
      var condition = propValue.condition,
        valueOrSignalRef = __rest(propValue, ["condition"]);
      var conditions = array(condition);
      var propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
      if (propIndex) {
        var vgProp = propIndex.vgProp,
          part = propIndex.part; // If there is a corresponding Vega property for the channel,
        // use Vega's custom axis encoding and delete the original axis property to avoid conflicts
        var vgRef = [].concat(_toConsumableArray(conditions.map(function (c) {
          var test = c.test,
            valueOrSignalCRef = __rest(c, ["test"]);
          return Object.assign({
            test: expression(null, test)
          }, valueOrSignalCRef);
        })), [valueOrSignalRef]);
        setAxisEncode(axis, part, vgProp, vgRef);
        delete axis[prop];
      } else if (propIndex === null) {
        // If propIndex is null, this means we support conditional axis property by converting the condition to signal instead.
        var signalRef = {
          signal: conditions.map(function (c) {
            var test = c.test,
              valueOrSignalCRef = __rest(c, ["test"]);
            return "".concat(expression(null, test), " ? ").concat(exprFromValueOrSignalRef(valueOrSignalCRef), " : ");
          }).join('') + exprFromValueOrSignalRef(valueOrSignalRef)
        };
        axis[prop] = signalRef;
      }
    } else if (isSignalRef(propValue)) {
      var _propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
      if (_propIndex) {
        var _vgProp = _propIndex.vgProp,
          _part = _propIndex.part;
        setAxisEncode(axis, _part, _vgProp, propValue);
        delete axis[prop];
      } // else do nothing since the property already supports signal
    }
  }
  if (kind === 'grid') {
    if (!axis.grid) {
      return undefined;
    }
    // Remove unnecessary encode block
    if (axis.encode) {
      // Only need to keep encode block for grid
      var grid = axis.encode.grid;
      axis.encode = Object.assign({}, grid ? {
        grid: grid
      } : {});
      if (isEmpty(axis.encode)) {
        delete axis.encode;
      }
    }
    return Object.assign(Object.assign({
      scale: scale,
      orient: orient
    }, axis), {
      domain: false,
      labels: false,
      aria: false,
      // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
      // would not affect gridAxis
      maxExtent: 0,
      minExtent: 0,
      ticks: false,
      zindex: getFirstDefined(zindex, 0) // put grid behind marks by default
    });
  } else {
    // kind === 'main'
    if (!opt.header && axisCmpt.mainExtracted) {
      // if mainExtracted has been extracted to a separate facet
      return undefined;
    }
    if (labelExpr !== undefined) {
      var expr = labelExpr;
      if (((_b = (_a = axis.encode) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.update) && isSignalRef(axis.encode.labels.update.text)) {
        expr = replaceAll(labelExpr, 'datum.label', axis.encode.labels.update.text.signal);
      }
      setAxisEncode(axis, 'labels', 'text', {
        signal: expr
      });
    }
    if (axis.labelAlign === null) {
      delete axis.labelAlign;
    }
    // Remove unnecessary encode block
    if (axis.encode) {
      var _iterator = _createForOfIteratorHelper(AXIS_PARTS),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _part2 = _step.value;
          if (!axisCmpt.hasAxisPart(_part2)) {
            delete axis.encode[_part2];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (isEmpty(axis.encode)) {
        delete axis.encode;
      }
    }
    var titleString = assembleTitle(title, config);
    return Object.assign(Object.assign(Object.assign(Object.assign({
      scale: scale,
      orient: orient,
      grid: false
    }, titleString ? {
      title: titleString
    } : {}), axis), config.aria === false ? {
      aria: false
    } : {}), {
      zindex: getFirstDefined(zindex, 0) // put axis line above marks by default
    });
  }
}
/**
 * Add axis signals so grid line works correctly
 * (Fix https://github.com/vega/vega-lite/issues/4226)
 */
export function assembleAxisSignals(model) {
  var axes = model.component.axes;
  var signals = [];
  var _iterator2 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var channel = _step2.value;
      if (axes[channel]) {
        var _iterator3 = _createForOfIteratorHelper(axes[channel]),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var axis = _step3.value;
            if (!axis.get('disable') && !axis.get('gridScale')) {
              // If there is x-axis but no y-scale for gridScale, need to set height/width so x-axis can draw the grid with the right height. Same for y-axis and width.
              var sizeType = channel === 'x' ? 'height' : 'width';
              var update = model.getSizeSignalRef(sizeType).signal;
              if (sizeType !== update) {
                signals.push({
                  name: sizeType,
                  update: update
                });
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return signals;
}
export function assembleAxes(axisComponents, config) {
  var _axisComponents$x = axisComponents.x,
    x = _axisComponents$x === void 0 ? [] : _axisComponents$x,
    _axisComponents$y = axisComponents.y,
    y = _axisComponents$y === void 0 ? [] : _axisComponents$y;
  return [].concat(_toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'grid', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'grid', config);
  })), _toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'main', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'main', config);
  }))).filter(function (a) {
    return a;
  }); // filter undefined
}